import { compose } from 'recompose';

import Col from './col';

const enhance = compose();
export default enhance(Col);
